require('./educations.module.js');
require('./controllers/education-request.controller');
require('./controllers/education-report.controller');
require('./controllers/education-users.controller');
require('./controllers/education-gallery-edit.controller');
require('./controllers/education-gallery-view.controller');